import { useEffect, useRef } from "react";

export default function PlaneGame() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current; // <- 把 current 存下來

    const phaserScript = document.createElement("script");
    phaserScript.src = "/games/plane/js/phaser.min.js";
    phaserScript.async = true;
    document.body.appendChild(phaserScript);

    let gameScript;

    phaserScript.onload = () => {
      gameScript = document.createElement("script");
      gameScript.src = "/games/plane/js/main.js";
      gameScript.type = "module";
      document.body.appendChild(gameScript);
    };

    return () => {
      if (phaserScript.parentNode) phaserScript.parentNode.removeChild(phaserScript);
      if (gameScript && gameScript.parentNode) gameScript.parentNode.removeChild(gameScript);

      // destroy Phaser
      if (window.game && typeof window.game.destroy === "function") {
        window.game.destroy(true);
        window.game = null;
      }

      // 移除 canvas（嚴謹做法：用當時 snapshot 下來的 DOM）
      if (container) {
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }
      }
    };
  }, []);

  return (
    <div>
      {/* share、logo 等元素留著，遊戲可用 */}
      <div id="share" className="share" style={{ display: "none" }}>
        <img className="sharepng" src="/games/plane/assets/share.png" alt="" />
        <img
          className="closebtn"
          src="/games/plane/assets/close.png"
          alt=""
          onClick={() => {
            document.getElementById('share').style.display = 'none';
          }}
        />
      </div>
      <div className="logo" style={{ display: "none" }}>
        <img src="/games/plane/assets/logo.jpg" alt="" />
      </div>

      <h2>Space Shooting</h2>
      <div
        id="game"
        ref={containerRef}
        style={{
          width: 240,
          height: 400,
          margin: "30px auto",
          border: "2px solid #2196f3",
          background: "#1a2333"
        }}
      />
    </div>
  );
}
